import plupload from "plugins/plupload";

const store = {
    namespaced: true,
    state: {
        uploads: []
    },
    mutations: {
        /**
         * Add a file into the upload section.
         *
         * @param {Object} state The store's state.
         * @param {Object} file The content.
         */
        addUpload: function(state, file) {
            state.uploads.push(file);
            plupload.add(file);
            plupload.start();
        },

        /**
         * Update a file (usually upload progress) from the upload section.
         *
         * @param {Object} state The store's state.
         * @param {Object} file The content.
         */
        setUpload: function(state, file) {
            let i = state.uploads.length;
            while(i--) {
                if (state.uploads[i].id === file.id) {
                    state.uploads.splice(i, 1, file);
                }
            }
        },

        /**
         * Remove a file from the upload section.
         *
         * @param {Object} state The store's state.
         * @param {Object} file The content.
         */
        removeUpload: function(state, file) {
            plupload.remove(file);
            let i = state.uploads.length;
            while(i--) {
                if (state.uploads[i].id === file.id) {
                    state.uploads.splice(i, 1);
                }
            }
        },

        /**
         * Stop all downloads currently happening (if any).
         *
         * @param {Object} state The store's state.
         */
        removeAllUploads: function(state) {
            let i = state.uploads.length;
            while(i--) {
                plupload.remove(state.uploads[i]);
            }
            // We erase completely the array
            state.uploads.splice(0, state.uploads.length);
        },

        /**
         * Set pending state.
         *
         * @param {Object} state The store's state.
         * @param {String} payload The name and value to set.
         */
        setPending: function(state, payload) {
            state.pending[payload.name] = payload.value;
        }
    }
};

export default store;